import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Flex,
  Button,
  Text,
} from '@chakra-ui/react';

const RequestReceivedModal = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent minH={"250px"} minW={"600px"} p={4} borderRadius={"16px"}>
        <ModalBody display={"flex"}>
          <Flex
            direction={"column"}
            justify={"center"}
            align={"center"}
            flex={1}
            gap={8}
          >
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"24px"}
              textTransform={"uppercase"}
            >
              WE HAVE SUCCESSFULLY RECEIVED YOUR REQUEST!
            </Text>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansRegular"
              fontSize={"16px"}
            >
              Your bag is on its way.
            </Text>
            <Button
              bg="#000000"
              borderRadius="12px"
              color="#FFFFFF"
              size="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"374px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={onClose}
              mt={2}
            >
              close
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default RequestReceivedModal;